export const formatDateWithOrdinal = (dateString: string | number | Date) => {
  const date = new Date(dateString);

  // Function to get the ordinal suffix for a day
  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return "th"; // covers 11th - 13th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const day = date.getDate(); // Use local date
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    date
  );
  const year = date.getFullYear(); // Use local year
  const ordinalSuffix = getOrdinalSuffix(day);

  return `${day}${ordinalSuffix} of ${month} ${year}`;
};
